module.exports = new __parcel__URL__("list-app-skeleton.tpl.82508714.svg").toString();